import './style.scss';

import { useEffect, useState } from 'react';

import { ReactComponent as ScrollHintIcon } from './scroll-hint.svg';

const ANIMATION_DELAY_MS = 3000;
const ANIMATION_DURATION_MS = 4000;
const STORAGE_KEY = 'scroll_hint_last_visit';
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

export default function ScrollHint() {
  const [isVisible, setIsVisible] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const lastVisit = localStorage.getItem(STORAGE_KEY);
    const now = Date.now();

    const isExpired = !lastVisit || now - parseInt(lastVisit) > THIRTY_DAYS_MS;
    localStorage.setItem(STORAGE_KEY, now.toString());

    if (!isExpired) return;

    const mountTimer = setTimeout(() => {
      setIsMounted(true);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setIsVisible(true);
        });
      });
    }, ANIMATION_DELAY_MS);

    const hideTimer = setTimeout(
      () => {
        setIsVisible(false);
        setIsMounted(false);
      },
      ANIMATION_DELAY_MS + ANIMATION_DURATION_MS * 2,
    );

    const handleUserScroll = () => {
      clearTimeout(mountTimer);
      clearTimeout(hideTimer);
      setIsVisible(false);
      setIsMounted(false);
    };

    window.addEventListener('wheel', handleUserScroll, { passive: true });
    window.addEventListener('touchmove', handleUserScroll, { passive: true });
    localStorage.setItem(STORAGE_KEY, now.toString());

    return () => {
      clearTimeout(mountTimer);
      clearTimeout(hideTimer);
      window.removeEventListener('wheel', handleUserScroll);
      window.removeEventListener('touchmove', handleUserScroll);
    };
  }, []);

  if (!isMounted) return null;

  return (
    <div
      className={`scroll-hint ${isVisible ? 'is-visible' : ''}`}
      aria-hidden="true"
      role="presentation">
      <ScrollHintIcon className="scroll-hint__icon" focusable="false" />
    </div>
  );
}
